import axios from 'axios';
import { getImpersonationHeader } from '../util';
import { apiGatewayBaseUrlPublic } from '../services';

// Public Instance
const publicInstance = axios.create({
  baseURL: apiGatewayBaseUrlPublic,
});

publicInstance.interceptors.request.use((config) => {
  config.headers = {
    'Content-Type': 'application/json',
    ...getImpersonationHeader(),
  };
  return config;
});

publicInstance.interceptors.response.use(
  (response) => {
    return response.data;
  },
  (error) => {
    return Promise.reject(error.response.data);
  },
);

export { publicInstance };
